import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

const AnalyticsList = ({ title, items, renderRight, dropdown = null, emptyMessage = null, className = '' }) => {
  const { t } = useTranslation('dashboard');
  const defaultEmptyMessage = emptyMessage || t('messages.noData');
  
  return (
  <div className={`list-card ${className}`.trim()}>
    <div style={{ marginBottom: dropdown ? 0 : '1rem' }}>
      <span><b>{title}</b></span>
    </div>
    {dropdown && (
      <div style={{ margin: '0.5rem 0 1rem 0', width: '100%' }}>
        {dropdown}
      </div>
    )}
    {(!items || items.length === 0) && (
      <div style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', textAlign: 'center', margin: '1rem 0' }}>{defaultEmptyMessage}</div>
    )}
    <ul className="touch-friendly">
      {items && items.map((item, idx) => (
        <li key={item.key || item.name || idx} className="analytics-list-item">
          <span className="analytics-list-name" style={{ flex: 1, minWidth: 0, wordBreak: 'break-word', whiteSpace: 'normal' }}>{item.rank !== undefined ? `${item.rank}. ` : ''}{item.name}</span>
          <span className="analytics-list-value" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', minWidth: 90 }}>
            {renderRight && renderRight(item, idx)}
          </span>
        </li>
      ))}
    </ul>
  </div>
  );
};

export default AnalyticsList; 